var exports = {
  "u": "xe7b6e3d6--5c7766--toggle-btn",
  "q": "xe7b6e3d6--5c7766--toggle-btn--close",
};

module.exports = exports;
